const getStyles = () => {
  return {
    sesstion_div: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: '"Inconsolata", monospace',
      fontWeight: '900'
    },
    gifimg: {
      width: '200px'
    },
    log_btn_sesstion: {
      background: 'red'
    },
    center: {
      textAlign: 'center'
    }
  };
};

export default getStyles;
